<template>
  <div class="main fullScreen" v-on:resize="handleResize()">
    <div class="projects__grid">
      <img class="arabic" src="../assets/arabic.svg" v-parallax="0.1" alt="">
      <div class="projects-grid__tile-row text1">
        <h2>{{ work[0].title }}</h2>
        <p>{{ work[0].description }}</p>
      </div>
      <a class="email" v-if="windowWidth > 780" :href="'mailto:' + general[0].contact.email"><h2>{{ general[0].contact.email }}</h2></a>
      <!-- I don't like this... I need a way to toggle custom directives on and off -->
      <template v-if="windowWidth >= 780 && windowWidth < 1280">
        <div class="tile-container parallax" v-parallax="parallax[index]" :class="'project_' + project.orderid + ' project'" v-for="(project, index) in projects" :key="index + '-parallax'">    
          <div class="image-container" @click="$router.push({ name: 'projects', params: { project_id: index }})" v-if="project.images">
            <img class="tile" :src="project.images[0].title" alt="">
            <div class="tile__background"></div>
            <div   class="tile__overlay">
              <p v-if="project.title" class="overlay__title">{{ project.title }}</p>
              <p v-if="project.types" class="overlay__subtitle">{{ project.types.type1 }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-if="windowWidth >= 1280">
        <div class="tile-container parallax" v-parallax="parallax[index]" :class="'project_' + project.orderid + ' project'" v-for="(project, index) in projects" :key="index + '-parallax'">        
          <div class="image-container" @click="$router.push({ name: 'projects', params: { project_id: index }})" v-if="project.images">
            <img class="tile" :src="project.images[0].title" alt="">
            <div class="tile__background"></div>
            <div   class="tile__overlay">
              <p v-if="project.title" class="overlay__title">{{ project.title }}</p>
              <p v-if="project.types" class="overlay__subtitle">{{ project.types.type1 }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-if="windowWidth < 780">
        <div class="tile-container parallax small" :class="'project_' + project.orderid" v-for="(project, index) in projects" :key="index">
          <div class="image-container" @click="$router.push({ name: 'projects', params: { project_id: index }})">
            <img class="tile" :src="project.images[0].title" alt="">
          </div>
          <div class="titles">
            <p v-if="project.title" class="overlay__title">{{ project.title }}</p>
            <p v-if="project.types" class="overlay__subtitle">{{ project.types.type1 }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'work',
  data: function () {
    return {
      parallax: [0.1, 0.0, 0.2, 0.0, 0.0, 0.1],
      windowWidth: window.innerWidth
    }
  },
  computed: {
    ...mapGetters([
      'general',
      'work',
      'projects'
    ])
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style scoped lang="scss">
@import "../scss/vars";

.small {
  & p {
    text-align: left;
  }
  & .titles {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  & .image-container {
    animation: none;
  }
}

.image-container {
  position: relative;
  overflow: hidden;
  object-fit: contain;
  cursor: pointer;
  &:hover .tile {
    transform: scale(1.2);
  }
  & .tile__background {
    background-color: $ray-light-blue;
    filter: opacity(75%);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: none;
  }
  &:hover .tile__background{
    display: block;
    content: '';
  }
  &:hover .tile__overlay{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
/*  animation: 2s ease 0s 1 slideInFromTop;*/
}
.overlay__title {
  color: $font-color__second;
  font-size: $font-size-title;
line-height: $font-size-title;
  text-align: center;
  margin: 0 0 0.5rem 0;
}
.overlay__subtitle {
  color: $font-color__second;
  font-size: $font-size-body;
  text-align: center;
  margin: 0;
}

@media screen and (max-width: $break-small) {
  .text1 {
    grid-column: 1;
    grid-row: 1 / span 1;
  }
  .arabic {
    grid-column: 2;
    grid-row: 1 / span 1;
    width: 100%;
  }
  .email{
    grid-column: 1 / span 1;
    grid-row: 2 / span 1;
    z-index: 10;
    &:hover {
      text-decoration: underline;
    }
  }
  .project_1 {
    grid-column: 2 / span 1;
    grid-row: 2 / span 2;
  }
  .project_2 {
    grid-column: 1 / span 1;
    grid-row: 3 / span 2;
  }
  .project_3 {
    grid-column: 2 / span 1;
    grid-row: 4 / span 2;
  }
  .project_4 {
    grid-column: 1 / span 1;
    grid-row: 5 / span 2;
  }
  .project_5 {
    grid-column: 2 / span 1;
    grid-row: 6 / span 2;
  }
  .project_6 {
    grid-column: 1 / span 1;
    grid-row: 7 / span 2;
  }
  .project_7 {
    grid-column: 2 / span 1;
    grid-row: 8 / span 2;
  }
  .project_8 {
    grid-column: 1 / span 1;
    grid-row: 9 / span 2;
  }
}

@media screen and (min-width: $break-small) and (max-width: $break-large) 
       
{
  .image-container {
    position: relative;
  }
    .text1 {
    grid-column: 8 / span 4;
    grid-row: 4;
    z-index: 5;
  }
  .arabic {
    grid-column: 8 / span 4;
    grid-row: 2;
    width: 100%;
  }
  .email{
    padding-left: 48px;
    grid-column: 1 / span 4;
    grid-row: 7;
    z-index: 10;
  }
  .project_1 {
    grid-column: 2 / span 4;
    grid-row: 1;
    z-index: 5;
  }
  .project_2 {
    grid-column: 4 / span 4;
    grid-row: 5;
  }
  .project_3 {
    grid-column: 6 / span 7;
    grid-row: 13;
  }
  .project_4 {
    grid-column: 12 / span 2;
    grid-row: 12;
  }
  .project_5 {
    grid-column: 1 / span 5;
    grid-row: 16;
  }
  .project_6 {
    grid-column: 2 / span 10;
    grid-row: 24;
  }
  .project_7 {
    grid-column: 1 / span 7;
    grid-row: 31;
  }
  .project_8 {
    grid-column: 7 / span 5;
    grid-row: 36;
  }
    //SO FAR ONLY UP TO 8 ON THE PAGE
  .project_9 {
    grid-column: 4 / span 9;
    grid-row: 42;
  }
  .project_10 {
    grid-column: 3 / span 5;
    grid-row: 21;
  }
  .project_11 {
    grid-column: 9 / span 5;
    grid-row: 21;
  }
}

@media screen and (min-width: $break-large) {
  .image-container {
    position: relative;
  }
  .text1 {
    grid-column: 8 / span 4;
    grid-row: 4;
    z-index: 5;
  }
  .arabic {
    grid-column: 9 / span 3;
    grid-row: 2;
    width: 100%;
  }
  .email{
    padding-left: 48px;
    grid-column: 1 / span 4;
    grid-row: 7;
    z-index: 10;
  }
  .project_1 {
    grid-column: 2 / span 4;
    grid-row: 1;
    z-index: 5;
  }
  .project_2 {
    grid-column: 4 / span 4;
    grid-row: 5;
  }
  .project_3 {
    grid-column: 6 / span 7;
    grid-row: 14;
  }
  .project_4 {
    grid-column: 12 / span 2;
    grid-row: 13;
  }
  .project_5 {
    grid-column: 1 / span 5;
    grid-row: 17;
  }
  .project_6 {
    grid-column: 2 / span 10;
    grid-row: 26;
  }
  .project_7 {
    grid-column: 1 / span 7;
    grid-row: 34;
  }
  .project_8 {
    grid-column: 7 / span 5;
    grid-row: 39;
  }
    //SO FAR ONLY UP TO 8 ON THE PAGE
  .project_9 {
    grid-column: 4 / span 9;
    grid-row: 42;
  }
  .project_10 {
    grid-column: 3 / span 5;
    grid-row: 21;
  }
  .project_11 {
    grid-column: 9 / span 5;
    grid-row: 21;
  }
}
    
@media screen and (min-width: $break-xlarge) {
  .image-container {
    position: relative;
  }
  .text1 {
    grid-column: 8 / span 4;
    grid-row: 4;
    z-index: 5;
  }
  .arabic {
    grid-column: 9 / span 3;
    grid-row: 2;
    width: 100%;
  }
  .email{
    padding-left: 48px;
    grid-column: 1 / span 4;
    grid-row: 7;
    z-index: 10;
  }
  .project_1 {
    grid-column: 2 / span 4;
    grid-row: 1;
    z-index: 5;
  }
  .project_2 {
    grid-column: 4 / span 4;
    grid-row: 5;
  }
  .project_3 {
    grid-column: 6 / span 7;
    grid-row: 17;
  }
  .project_4 {
    grid-column: 12 / span 2;
    grid-row: 13;
  }
  .project_5 {
    grid-column: 1 / span 5;
    grid-row: 22;
  }
  .project_6 {
    grid-column: 2 / span 10;
    grid-row: 36;
  }
  .project_7 {
    grid-column: 1 / span 7;
    grid-row: 47;
  }
  .project_8 {
    grid-column: 7 / span 5;
    grid-row: 84;
  }
    //SO FAR ONLY UP TO 8 ON THE PAGE
  .project_9 {
    grid-column: 4 / span 9;
    grid-row: 42;
  }
  .project_10 {
    grid-column: 3 / span 5;
    grid-row: 21;
  }
  .project_11 {
    grid-column: 9 / span 5;
    grid-row: 21;
  }
}
    
.fullScreen {
    margin-top: 132px;
    padding: 0px;
} 

</style>
